/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Button } from 'reactstrap';
import CTLightLogo from '../../../images/apps/Company_Tracker_logo.svg';
import RequestDemoModal from '@features/request-demo-modal';
import { BaseStepCompProps } from '../types';

interface CompanyNotAllowedProps extends Pick<BaseStepCompProps, 'handlePrevious'> {
  description: string;
}

export const CompanyNotAllowed = (props: CompanyNotAllowedProps) => {
  const { handlePrevious, description } = props;
  const [isRequestModalOpen, setRequestModalOpen] = useState(false);

  const handleFreeTrial = () => setRequestModalOpen(true);
  const handleBookADemo = () => setRequestModalOpen(true);

  return (
    <div className='d-lg-flex justify-content-between onboarding-form'>
      <aside className='title-container'>
        <div className='h1 mb-3'>Not a Singapore Listco?</div>
        <p>
          <u>
            <a href='mailto:support@g17.eco' className='text-ThemeHeadingLight'>
              Contact us if you think this is a mistake
            </a>
          </u>
        </p>
      </aside>
      <section className='form-container mt-5'>
        <div className='strong mb-2'>Company Tracker?</div>
        <p>{description}</p>
        <p>However, we have a similar product available for you:</p>

        <div className='row mt-4'>
          <div className='col-3'>
            <img src={CTLightLogo} alt={'Company Tracker'} />
          </div>
          <div className='col'>
            Company Tracker is ESGenome for non-listcos. Instant onboarding, and free trial.
            <div className='text-right mt-2'>
              <Button outline onClick={handleFreeTrial}>Sign up for free trial</Button>
            </div>
            <div className='text-right mt-2'>
              <Button outline onClick={handleBookADemo}>Book a demo</Button>
            </div>
          </div>
        </div>

        <div className='mt-4'>
          <Button color='link-secondary' onClick={handlePrevious}><i className='far fa-angle-left mr-2' />Back</Button>
        </div>
      </section>

      <RequestDemoModal isOpen={isRequestModalOpen} toggle={() => setRequestModalOpen(false)} />
    </div>
  );
}
